<script setup lang="ts"></script>

<template>
  <tpg-loader />
</template>
